import useIsNative from '@/hooks/native/useIsNative';
import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react';
import { FC, useState } from 'react';
import Button from '../Button/Button';
import ArrowRightIcon from '../Icon/ArrowRightIcon';
import LargeSquareBackground from '../LargeSquareBackground/LargeSquareBackground';
import WordMarkLogo from '../WordMarkLogo/WordMarkLogo';
import appStoreQr from './appStore.svg';
import playStoreQr from './playStore.svg';

const appStores = [
	{
		displayName: 'Google Play',
		qrCodeSrc: playStoreQr,
		url: 'https://play.google.com/store/apps/details?id=nl.ntr.hetklokhuis.soortsafari',
	},
	{
		displayName: 'App Store',
		qrCodeSrc: appStoreQr,
		url: 'https://apps.apple.com/nl/app/soortsafari-het-klokhuis/id6502991093',
	},
] as const satisfies {
	displayName: string;
	qrCodeSrc: string;
	url: string;
}[];

export const AppUpsell: FC = () => {
	const isNative = useIsNative();

	const [isOpen, setIsOpen] = useState(!isNative);

	if (isNative) return null;

	const openAppStore = (url: string) => window.open(url, '_blank');

	return (
		<Dialog open={isOpen} onClose={() => setIsOpen(false)}>
			<DialogPanel className="fixed inset-0 z-50 size-full min-h-0 overflow-y-auto p-4 py-16">
				<div className="fixed inset-0 bg-primary opacity-80" />

				<div className="relative mx-auto flex justify-center pb-6">
					<WordMarkLogo />
				</div>

				<DialogTitle className="relative pb-16 text-center text-3xl font-bold text-white">
					Download de app!
				</DialogTitle>

				<ul className="relative mx-auto grid w-full max-w-3xl gap-16 pb-16 md:grid-cols-2">
					{appStores.map((appStore) => (
						<li
							key={appStore.displayName}
							className="relative mx-auto p-4"
							onClick={() => openAppStore(appStore.url)}>
							<LargeSquareBackground className="scale-110 cursor-pointer text-white" />
							<div className="relative grid gap-4">
								<h2 className="sr-only text-2xl text-white">
									{appStore.displayName}
								</h2>
								<img
									src={appStore.qrCodeSrc}
									alt={`QR code voor ${appStore.displayName}`}
									className="size-64 rounded-3xl"
								/>
								<Button
									label={appStore.displayName}
									className="mx-auto"
									icon={<ArrowRightIcon className="size-6" />}
									backgroundClassName="text-accent"
									onClick={() => openAppStore(appStore.url)}
								/>
							</div>
						</li>
					))}
				</ul>

				<button
					className="relative w-full text-center font-semibold text-white underline"
					onClick={() => setIsOpen(false)}>
					Website bekijken
				</button>
			</DialogPanel>
		</Dialog>
	);
};
